import React, { useContext, useEffect, useState } from "react";
import intl from "react-intl-universal";
import { mdiDownload } from "@mdi/js";
import styled from "styled-components";
import commonUtils from "../../../../../script/utils/commonUtils";

import { Grid } from "../../../../components/Grid";
import { Button } from "../../../../components/Button";
import { EntryContext } from "../../../../contexts/EntryContext";

const LayerStyle = styled.div`
    display: ${props => (props.$show ? "flex" : "none")};
`;

const layerName = "downloadLayer";

export const DownloadLayer = props => {
    const { plot, show } = props;

    const entryContext = useContext(EntryContext);
    const { entry } = entryContext;

    const [selection, setSelection] = useState(false);

    useEffect(() => {
        const layer = plot.addLayer(layerName, 140);
        layer.onDeactivate(() => layer.removeObjects());
        const feature = plot.applyRectFeature(layer, "rgba(0,0,255,0.3)", false);
        feature.onSelect(rect => setSelection(rect));
    }, []);

    useEffect(() => {
        if (show) {
            plot.getLayer(layerName).activate();
        }
    }, [show]);

    const onDownloadCanvas = () => {
        //const jpegUrl = plotUtils.generatePngUrl(plot);
        const jpegUrl = plot.toPngDataUrl();
        commonUtils.download(jpegUrl, entry.name + ".png");
        setSelection(undefined);
    };

    const onDownloadSelection = () => {
        const jpegUrl = plot.toPngDataUrl(selection);
        commonUtils.download(jpegUrl, entry.name + ".png");
        setSelection(undefined);
    };

    return (
        <LayerStyle $show={show}>
            <Grid columns="1">
                <Button
                    simulateLoading
                    svgIcon={mdiDownload}
                    onClick={() => onDownloadCanvas()}
                    value={intl.get("entry.plan.download.downloadCanvas")} />
                <Button
                    simulateLoading
                    svgIcon={mdiDownload}
                    disabled={!selection}
                    onClick={() => onDownloadSelection()}
                    value={intl.get("entry.plan.download.downloadSelection")} />
            </Grid>
        </LayerStyle>
    );
};